import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [seconds, setSeconds] = useState(23 * 3600 + 47 * 60 + 12);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const m = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-wine text-cream" style={{
    height: 40
  }} role="banner" data-id="element-207">
      <div className="mx-auto flex h-full max-w-container items-center justify-center px-4 text-center" data-id="element-208">
        <p className="text-[12px] font-medium sm:text-[13px]" data-id="element-209">
          <span aria-hidden="true" data-id="element-210">🔥</span>{' '}
          <span data-id="element-211">OFERTA DE LANZAMIENTO · Solo por 48 horas · 63% OFF · </span>
          <span className="tabular-nums font-semibold tracking-wider" data-id="element-212">
            {h}:{m}:{s}
          </span>
        </p>
      </div>
    </div>;
}